import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Badge, Box, Group, Space, Text } from "@mantine/core";

import { getEnvBadgeName } from "@components/EnvAlert";

import LaRucheLogo from "@assets/misc/logo-icon.svg?react";

import { StyledFooter } from "./Footer.styled";


const envColors: Record<string, string> = {
  development: "pink",
  staging: "yellow",
  production: "green",
};

export const Footer = () => {
  const { t } = useTranslation();
  const env = import.meta.env.VITE_ENV_BADGE as string;

  return (
    <StyledFooter>
      <div className="footer-content">
        <p>
          <span>{t("support")}:</span>&nbsp;+225 05 02 87 68 87 •&nbsp;
          <Link to="mailto:engineering@laruche.health">
            engineering@laruche.health
          </Link>
        </p>
        <p>
          <span className="dismissable-copyright">
            &copy; {new Date().getFullYear()}
          </span>
          <LaRucheLogo />
          <span className="dismissable-name">
            La Ruche Health
            {/* {t("all-rights-reserved")} */}
          </span>
          {env === "production" ? null : (
            <Badge bg="white" c="black" ml={7}>
              <Group gap={0}>
                <Box
                  bg={envColors[env]}
                  style={{
                    display: "inline-flex",
                    borderRadius: "50%",
                    width: 10,
                    height: 10,
                  }}></Box>
                <Space w={{ base: 3, md: 7 }} />
                <Text span fz={11} c={`${envColors[env]}.8`} fw={500} lh={1.5}>
                  {getEnvBadgeName(env)}
                </Text>
              </Group>
            </Badge>
          )}
        </p>
      </div>
    </StyledFooter>
  );
};
